import { render } from "./requests.vue?vue&type=template&id=62e4823c&scoped=true"
import script from "./requests.vue?vue&type=script&lang=js"
export * from "./requests.vue?vue&type=script&lang=js"

import "./requests.vue?vue&type=style&index=0&id=62e4823c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62e4823c"]])

export default __exports__